import React, { useState, useEffect, useContext, useCallback } from 'react';
import api from 'services/api';
import config from 'config';
import DOMPurify from 'dompurify';
import POPUP from '../popup';
import { CidadeContext } from 'services/cidade';
import './style.css';


const AvisoPopup = () => {
    const [avisos, setAvisos] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const {cod_cidade} =  useContext(CidadeContext);

    const getAvisos = useCallback(async () => {
        try {
            const response = await api.get(`${config.AVISOS}?cod_cidade=${cod_cidade}`);
            const data = response.data;

            // Verifica se há avisos na resposta
            if (data && data.length > 0) {
                return data;
            }

            return [];
        } catch (error) {
            console.error('Erro ao buscar avisos:', error);
            return [];
        }
    }, [cod_cidade]);

    useEffect(() => {
        const fetchAvisos = async () => {
            const avisosFromServer = await getAvisos();
            if (avisosFromServer.length > 0) {
                setAvisos(avisosFromServer);
                setShowPopup(true);
            }
        };

        fetchAvisos();
    }, [getAvisos]);

    const closePopup = () => {
        setShowPopup(false);
    };
    const formatTextWithNewlines = (text) => {
        if (!text) return '';
        // Substituir quebras de linha (\n) por <br />
        const formattedText = text.replace(/\n/g, '<br />');
                                 
        // Limpar o HTML com DOMPurify
        return DOMPurify.sanitize(formattedText);
    };

    return (
        showPopup && (
            <POPUP
                trigger={showPopup}
                setTrigger={setShowPopup}
            >
                <div className="aviso-container">
                    <div className="aviso-header">
                        <div className="aviso-icon-badge">
                            <i className="fas fa-bell"></i>
                        </div>
                        <h2>Novos Avisos</h2>
                        <p className="aviso-subtitle">Fique por dentro das novidades</p>
                    </div>
                    
                    <div className="aviso-list">
                        {avisos.map((n, index) => {
                            const imagemValida = n.image && n.image !== '' && !n.image.endsWith('/');
                            return (
                                <div key={`nof${index}`} className='aviso-item'>
                                    {imagemValida && (
                                        <div className='aviso-image-container'>
                                            <img src={n.image} alt={n.title} className="aviso-image" />
                                        </div>
                                    )}
                                    <div className='aviso-content'>
                                        <h3>{n.title}</h3>
                                        <div 
                                            dangerouslySetInnerHTML={{ __html: formatTextWithNewlines(n.body) }} 
                                            className="aviso-text"
                                        ></div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="aviso-footer">
                        <button onClick={closePopup} className="aviso-btn-close">
                            Entendi
                        </button>
                    </div>
                </div>
            </POPUP>
        )
    );
};

export default AvisoPopup;
